import indicadorReportSummary from "entity/Indicador/reports/IndicadorReportSummary";
import TableReportHelper from "report/helper";

export default async function ngvReportSummary(indicador, visita, tipoName) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;

    const params = visita.cliente.getParams(IndicadorClass, tipoName, indicador.type)

    if (!params) {
        return null;
    }

    const chartSegments = [0, 80, parseInt(params.meta), 100];

    async function getChart(conformidade) {
        return h.gaugeChart(
            {
                width: 200,
                height: 130,
                maxSegmentLabels: 5,
                customSegmentStops: chartSegments,
                segments: 3,
                segmentsColors: ["#fe4719", "#ecdb23", "#6bd72d"],
                series: [{ name: "", values: conformidade }],
            },
            { alignment: "center", colSpan: 3 }
        );
    }

    return indicadorReportSummary(indicador, visita, tipoName, params, getChart);
}
